// TabContent1.js
import React, { useEffect, useState } from 'react';
import ProgressionTab from '../../../../theme/ProgressionBuilder/ProgressionTab';
import Subheading from '../../../../theme/text/Subheading';
import SelectGroup from '../../../../theme/Select/SelectGroup';
import NumberInput from '../../../../theme/inputs/NumberInput';
import { useTheme } from '@emotion/react';
import Text from '../../../../theme/text/Text';
import { useTranslation } from 'react-i18next';
import { Box, FormControl, InputBase, InputLabel, Select, Typography } from '@mui/material';
import { tokens } from '../../../../../theme';
import { MenuItem } from 'react-pro-sidebar';
import { useGetUsergroupsSelectQuery } from '../../../../../newapi/user/usergroupSlice';
import { InputDropdown } from '../../../../theme/dropdowns/InputDropdown';
import { setTabErrors } from '../../../../../newapi/global/progressionTabSlice';
import * as yup from "yup";
import ShValidatedInput from '../../../../theme/inputs/ShValidatedInput';
import { yupRequired } from '../../../../../utils/validation';
import { useDispatch, useSelector } from 'react-redux';
/**
 * TabContent1 Component
 * 
 * Props:
 * - handleDataUpdate: Function, updates the data in the Redux state.
 * - handleNext: Function, navigates to the next tab.
 */
const Content = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const colors = tokens(theme.palette.mode);

    const data = {...props.data};
    const dispatch = useDispatch();

    const handleChange = (key, val) => {
        props.handleDataUpdate({ [key]: val });
        dispatch(setTabErrors({ ...props.errors, [key]: '' }));
    };

    const { data: usergroups } = useGetUsergroupsSelectQuery();

    useEffect(() => {
        // Set dummy data if existing
        if (data.existing) {
            props.handleDataUpdate({ firstname: "sh_dummy", lastname: "sh_dummy", password: "sh_dummy"});
        } else if (!data.existing) {
            if (data.firstname === "sh_dummy") {
                props.handleDataUpdate({ firstname: null});
            }
            if (data.lastname === "sh_dummy") {
                props.handleDataUpdate({ lastname: null});
            }
            if (data.password === "sh_dummy") {
                props.handleDataUpdate({ password: null});
            }
        }
    },[])

    return (
        <>
        {!data.existing && (
        <div>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,
                    "@media screen and (max-width: 47.9375em)": {
                        flexDirection: "row",
                        gap: 5,
                        alignItems: "center",
                        width: 1
                    }
                }}
            >
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            width: 80
                        }
                    }}
                >
                    <Text>{t("firstname")}</Text>
                </Box>
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            flex: 1
                        }
                    }}
                >
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            marginTop: 0.5,
                            
                        }}
                    >
                        <ShValidatedInput
                            name="firstname"
                            value={data.firstname ?? ""}
                            onChange={handleChange}
                            error={props.errors.firstname}
                        />
                       </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 2,
                    gap: 0.5,
                    "@media screen and (max-width: 47.9375em)": {
                        flexDirection: "row",
                        gap: 5,
                        alignItems: "center",
                        width: 1
                    }
                }}
            >
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            width: 80
                        }
                    }}
                >
                    <Text>{t("insertion")}</Text>
                </Box>
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            flex: 1
                        }
                    }}
                >
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            marginTop: 0.5,
                            
                        }}
                    >
                        <ShValidatedInput
                            name="insertion"
                            value={data.insertion ?? ""}
                            onChange={handleChange}
                            error={props.errors.insertion}
                        />
                       </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 2,
                    gap: 0.5,
                    "@media screen and (max-width: 47.9375em)": {
                        flexDirection: "row",
                        gap: 5,
                        alignItems: "center",
                        width: 1
                    }
                }}
            >
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            width: 80
                        }
                    }}
                >
                    <Text>{t("lastname")}</Text>
                </Box>
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            flex: 1
                        }
                    }}
                >
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            marginTop: 0.5,
                            
                        }}
                    >
                        <ShValidatedInput
                            name="lastname"
                            value={data.lastname ?? ""}
                            onChange={handleChange}
                            error={props.errors.lastname}
                        />
                        </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 2,
                    gap: 0.5,
                    "@media screen and (max-width: 47.9375em)": {
                        flexDirection: "row",
                        gap: 5,
                        alignItems: "center",
                        width: 1
                    }
                }}
            >
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            width: 80
                        }
                    }}
                >
                    <Text>{t("usergroup")}</Text>
                </Box>
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            flex: 1
                        }
                    }}
                >
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            marginTop: 0.5,
                            background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                            "@media screen and (max-width: 47.9375em)": {
                                background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                            }
                        }}
                    >
                    
            <InputDropdown
                displayName={"name"} 
                onChange={(selected) => handleChange("usergroup_id", usergroups[selected].id ?? -1)}
                noSelection={t("choose_usergroup")} //Custom text when nothing is selected
                options={usergroups}
                selected={usergroups?.findIndex(usergroup => usergroup.id === data.usergroup_id) ?? -1}
                closeOnSelection
            />
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 2,
                    gap: 0.5,
                    "@media screen and (max-width: 47.9375em)": {
                        flexDirection: "row",
                        gap: 5,
                        alignItems: "center",
                        width: 1
                    }
                }}
            >
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            width: 80
                        }
                    }}
                >
                    <Text>{t("password")}</Text>
                </Box>
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            flex: 1
                        }
                    }}
                >
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            marginTop: 0.5,
                            
                        }}
                    >
                        <ShValidatedInput
                            name="password"
                            type="password"
                            value={data.password ?? ""}
                            onChange={handleChange}
                            error={props.errors.password}
                        />
                       
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 2,
                    gap: 0.5,
                    "@media screen and (max-width: 47.9375em)": {
                        flexDirection: "row",
                        gap: 5,
                        alignItems: "center",
                        width: 1
                    }
                }}
            >
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            width: 80
                        }
                    }}
                >
                    <Text>{t("employee_code")}</Text>
                </Box>
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            flex: 1
                        }
                    }}
                >
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            marginTop: 0.5,
                            
                        }}
                    >
                        <ShValidatedInput
                            name="employee_code"
                            value={data.employee_code ?? ""}
                            onChange={handleChange}
                            error={props.errors.employee_code}
                        />
                       </Box>
                </Box>
            </Box>
        </div>
        )}
        {data.existing && (
            <>
            <Box 
                sx={{
                    background: colors["orange"][100],
                    color: colors["orange"][400],
                    padding:2,
                    width:1,
                    marginTop:2
                }}
            >
                <Typography fontWeight={"bold"} fontSize={"17"}>
                    {t("mp_add_user_confirm_title")}
                </Typography>
                <Box sx={{paddingTop:0.5}}>
                    <Typography fontSize={"14"}>
                    {t("mp_add_user_confirm_text")}
                    </Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: 2,
                    gap: 0.5,
                    "@media screen and (max-width: 47.9375em)": {
                        flexDirection: "row",
                        gap: 5,
                        alignItems: "center",
                        width: 1
                    }
                }}
            >
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            width: 80
                        }
                    }}
                >
                    <Text>{t("usergroup")}</Text>
                </Box>
                <Box
                    sx={{
                        "@media screen and (max-width: 47.9375em)": {
                            flex: 1
                        }
                    }}
                >
                    <Box display="flex"
                        borderRadius="20px"
                        sx={{
                            marginTop: 0.5,
                            background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                            "@media screen and (max-width: 47.9375em)": {
                                background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                            }
                        }}
                    >
                    
            <InputDropdown
                displayName={"name"} 
                onChange={(selected) => handleChange("usergroup_id", usergroups[selected].id ?? -1)}
                noSelection={t("choose_usergroup")} //Custom text when nothing is selected
                options={usergroups}
                selected={usergroups?.findIndex(usergroup => usergroup.id === data.usergroup_id) ?? -1}
                closeOnSelection
            />
                    </Box>
                </Box>
            </Box>
            </>
        )}
        </>
    );
};

const UserBasicInfo = (props) => {
    const { t } = useTranslation();

    const schema = yup.object({
        firstname: yupRequired('firstname',t),
        lastname: yupRequired('lastname',t),
        password: yup.string()
    });

    return (
        <ProgressionTab
            tabId="tabBasicInfo"
            subtitle={"details"}
            step={2}
            //nextTab={"tab"}
            schema={schema}
            maxSteps={2}
        >
            <Content />
        </ProgressionTab>
    )
}

export default UserBasicInfo;

